import React, { Component } from "react";
import { Select, DatePicker, Input, Collapse, Table, Modal, Form, Spin } from "antd";
import Translate from "../translate";
import Api from "../ServiceApi";
import Cookies from "js-cookie";
import moment from "moment";
import ChangePath from "../../services/ServiceApi";
const { Option } = Select;
const { RangePicker } = DatePicker;
const { Panel } = Collapse;
const dateFormatList = ["DD/MM/YYYY", "YYYY/MM/DD", "YYYY-MM-DD"];
// const delDetail = (item) =>{
//   //console.log('delDetail : ',item);
// }
// const columns = [
//   {
//     title: "Asset Code",
//     dataIndex: "asset_code",
//     key: "asset_id",
//   },
//   {
//     title: "Location Name",
//     dataIndex: "location_name",
//     key: "location_name",
//     render: (item) => (
//       <span className="c-blue">{item === null ? "-" : item}</span>
//     ),
//   },
//   {
//     title: "Job Category",
//     dataIndex: "job_category_name",
//     key: "job_category_name",
//   },
//   {
//     title: "Job Type",
//     dataIndex: "job_type_name",
//     key: "job_type_name",
//   },
//   // {
//   //   title: "Period",
//   //   dataIndex: "period",
//   //   key: "period",
//   //   render: (item) => (
//   //     <span className="c-blue">{item === null ? "-" : item}</span>
//   //   ),
//   // },
//   {
//     title: "Action",
//     dataIndex: "",
//     key: "",
//     render: (item) => (     
//       <div>
//         {/*console.log('del : ',item)
//          <a href="#">
//           <img src={Api.absoluteUrl("/icon/edit.svg")} />
//         </a> */}
//         <a href="#">
//           <img onClick={async () => {
//             console.log('click del : ',item)
//             const spDeleteDetailById = await Api.post("spDeleteDetailById", {
//               company_id: Cookies.get("companyid"),
//               pm_detail_id: item.pm_detail_id,
//               emp_service_pm_id: item.emp_service_pm_id
//             })
//             window.location.reload()
            
//             // console.log('start_date',this.state.start_date);
//             // console.log('end date',this.state.end_date);


//             //console.log('onClick Action : ',JobListEmployee)

//           }
//             } src={Api.absoluteUrl("/icon/delete.svg")} />
//         </a>
//       </div>
//     ),
//   },
// ];

// delDetail(item){
//   console.log('delDetail : ',item);
// }

class ListPlan extends Component {
  startEnd = React.createRef();
  constructor(props) {
    super(props);
    this.columns = [
      {
        title: "Planning Name",
        dataIndex: "plan_name",
        key: "plan_name",
      },
      {
        title: "Asset Code",
        dataIndex: "asset_code",
        key: "asset_id",
      },
      {
        title: "Location Name",
        dataIndex: "location_name",
        key: "location_name",
        render: (item) => (
          <span className="c-blue">{item === null ? "-" : item}</span>
        ),
      },
      {
        title: "Job Category",
        dataIndex: "job_category_name",
        key: "job_category_name",
      },
      {
        title: "Job Type",
        dataIndex: "job_type_name",
        key: "job_type_name",
      },
      // {
      //   title: "Period",
      //   dataIndex: "period",
      //   key: "period",
      //   render: (item) => (
      //     <span className="c-blue">{item === null ? "-" : item}</span>
      //   ),
      // },
      {
        title: "Action",
        dataIndex: "",
        key: "",
        render: (item) => (     
          <div>
             {/* <a onClick={ () => {
               console.log('click edit : ',item)
               this.setState({
                visible_edit : true,
                item_edit : item
              })  
             } }>
              <img src={Api.absoluteUrl("/icon/edit.svg")} />
            </a>  */}
            {/* <a href="javascript:void(0)"> */}
            <button >
              <img onClick={ () => {
                console.log('click del : ',item)
                console.log('click active : ',this.state.active)
                if(this.state.active === 0){
                  this.setState({
                    visible_del : true,
                    item_del : item
                  }) 
                }else{
                  console.log('del manual');
                  this.setState({
                    visible_manual_del : true,
                    item_del : item
                  }) 
                }
                               

                // const spDeleteDetailById = await Api.post("spDeleteDetailById", {
                //   company_id: Cookies.get("companyid"),
                //   pm_detail_id: item.pm_detail_id,
                //   emp_service_pm_id: item.emp_service_pm_id
                // })
                // window.location.reload()
                
                // console.log('start_date',this.state.start_date);
                // console.log('end date',this.state.end_date);
    
    
                //console.log('onClick Action : ',JobListEmployee)
    
              }
                } src={Api.absoluteUrl("/icon/delete.svg")} alt="delete-ic" />
            </button>
          </div>
        ),
      },
    ];
    
    this.state = {
      team: [],
      employee: [],
      active: 0,
      data: [],
      data_emp: [
      ],
      //tab: [{ title: "tab_team" }, { title: "tab_employee" }],
      tab: [{ title: "job" }],
      //tab: [{ title: "job" }],
      active_tab: 0,
      data_team: [],
      data_job:[],
      data_plan:[],
      start_date: moment(new Date()).format("YYYY/MM/DD"),
      end_date: moment(new Date()).add(6, "day").format("YYYY/MM/DD"),
      count_job:0,
      count_all:0,
      count_plan:0,
      visible_del:false,
      visible_manual_del:false,
      item_del:{},
      visible_edit:false,
      item_edit:{},
      selectedRowKeys: [],
      currentPage: 1,
      array_list: [],
      rowRecords: [],
      checkKeys: [],
      disabled_button:true,
      visible_start_end: false,
      modal_log: "",
      loading_start_end: false
    };
  }
  async componentDidMount() {
    // const JobListEmployee = await Api.post("v2/planningJobListEmployee", {
    //   company_id: Cookies.get("companyid"),
    //   operator_id: Cookies.get("operator_id"),
    //   project_id: Cookies.get("project_id"),
    //   work_pm_start: moment(this.state.start_date).format("YYYY-MM-DD"),
    //   work_pm_end: moment(this.state.end_date).format("YYYY-MM-DD"),
    //   group_id: null ,
    //   group_name: null
    // });
    // const JobListTeam = await Api.post("planningJobListTeam", {
    //   company_id: Cookies.get("companyid"),
    //   operator_id: Cookies.get("operator_id"),
    //   project_id: Cookies.get("project_id"),
    //   work_pm_start: moment(this.state.start_date).format("YYYY-MM-DD"),
    //   work_pm_end: moment(this.state.end_date).format("YYYY-MM-DD"),
    //   group_id: null ,
    //   group_name: null
    // });
    // // console.log(JobListTeam,'JobListTeam');
    // this.setState({
    //   team: JobListTeam.data.data,
    //   employee: JobListEmployee.data.data,
    // });

    const plan_manual = await Api.post("v2/getAllPlanningMain", {
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
      auto_gen_job: 0,
      // work_pm_start: moment(this.state.start_date).format("YYYY-MM-DD"),
      // work_pm_end: moment(this.state.end_date).format("YYYY-MM-DD"),
      group_id: null ,
      group_name: null,
    });

    console.log(plan_manual,'plan_manual');
    //count_plan

    const calendar_list = await Api.post("v2/planningJobCalendarList", {// count all plan (no assign) >> ใช้งานอยู่
      work_pm_start: moment().format("YYYY-MM-DD"),
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
      group_id: null ,
      group_name: null,
    });
    //console.log(calendar_list.data.data.length,'calendar_list');
    
    const s_date = moment(new Date()).format("YYYY/MM/DD")
        const e_date   = moment(new Date()).add(6, "day").format("YYYY/MM/DD")
        const job_data = await Api.post("v2/jobNoAssetCalenderAll", {
          team_group_id: 0,
          team_id:0,
          company_id: Cookies.get("companyid"),
          operator_id: Cookies.get("operator_id"),
          project_id: Cookies.get("project_id"),
          work_pm_start: s_date,
          work_pm_end: e_date,
          group_id: null ,
          group_name: null,
        });
    let count_job = 0;
    let JobAll = JSON.parse(JSON.stringify(job_data)); // clone
    //const JobAll = job_data
    console.log('JobAll',JobAll);
    if(JobAll.data.data !== undefined || JobAll.data.data !== null){
      //console.log('JobAll : ',JobAll.data.data)
      for(let i=0;i<JobAll.data.data.length;i++){
        count_job += JobAll.data.data[i]['asset_calender_detail'].length
        // console.log('JobAll asset_calender_detail ',JobAll.data.data[i]['asset_calender_detail']);
        for(let j=0;j<JobAll.data.data[i]['asset_calender_detail'].length;j++){
          // console.log(i+'asset_id '+JobAll.data.data[i]['asset_calender_detail'][j].asset_id);
          if(JobAll.data.data[i]['asset_calender_detail'][j].asset_id === null){
            //console.log('assign');
            JobAll.data.data[i]['asset_calender_detail'][j].asset_id = 'Asset List (ID:'+JobAll.data.data[i]['asset_calender_detail'][j].emp_service_pm_id+')'
            JobAll.data.data[i]['asset_calender_detail'][j].asset_code = 'Asset List (ID:'+JobAll.data.data[i]['asset_calender_detail'][j].emp_service_pm_id+')'
          }
          
        }
      }
      
      // console.log('after JobAll',JobAll.data.data);
      //this.renderDetail(0, JobAll.data.data[0], "job");
      this.renderDetail(0, JobAll.data.data, "job");
    }

    this.setState({
      count_job : calendar_list.data.data.length,
      count_all : count_job,
      count_plan : plan_manual.data.data.length,
      data_plan : plan_manual.data.data
    })

  }

  onModalOK = async () => {
    const { item_del, start_date ,end_date } = this.state
    console.log('OK');
    // console.log('onModalOK start_date',start_date);
    // console.log('onModalOK end_date',end_date);

    await Api.post("spDeleteDetailById", {
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
      pm_detail_id: item_del.pm_detail_id,
      emp_service_pm_id: item_del.emp_service_pm_id
    })
    // console.log('spDeleteDetailById',spDeleteDetailById);

    
    const job_data = await Api.post("v2/jobNoAssetCalenderAll", {
      team_group_id: 0,
      team_id:0,
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
      work_pm_start: start_date,
      work_pm_end: end_date,
      group_id: null ,
      group_name:  null,
    });
    let count_job = 0;
    let JobAll = JSON.parse(JSON.stringify(job_data)); // clone
    if(JobAll.data.data !== undefined || JobAll.data.data !== null){
      //console.log('JobAll : ',JobAll.data.data)
      for(let i=0;i<JobAll.data.data.length;i++){
        count_job += JobAll.data.data[i]['asset_calender_detail'].length
        // console.log('JobAll asset_calender_detail ',JobAll.data.data[i]['asset_calender_detail']);
        for(let j=0;j<JobAll.data.data[i]['asset_calender_detail'].length;j++){
          // console.log(i+'asset_id '+JobAll.data.data[i]['asset_calender_detail'][j].asset_id);
          if(JobAll.data.data[i]['asset_calender_detail'][j].asset_id === null){
            //console.log('assign');
            JobAll.data.data[i]['asset_calender_detail'][j].asset_id = 'Asset List (ID:'+JobAll.data.data[i]['asset_calender_detail'][j].emp_service_pm_id+')'
            JobAll.data.data[i]['asset_calender_detail'][j].asset_code = 'Asset List (ID:'+JobAll.data.data[i]['asset_calender_detail'][j].emp_service_pm_id+')'
          }
          
        }
      }
      // console.log('after JobAll',JobAll.data.data);
      //this.renderDetail(0, JobAll.data.data[0], "job");
      this.renderDetail(0, JobAll.data.data, "job");
    }
    

    //window.location.reload()


    this.setState({
      visible_del : false,
      count_all : count_job
    })
  }

  onModalCancel = () => {    
    // const { visible_del } = this.state
    console.log('Cancel');
    this.setState({
      visible_del : false
    })
  }
  
  onModalConfirm(){    
    // const { visible_del } = this.state
    // Modal.confirm({
    //   title: 'ยืนยันการลบข้อมูล',
    //   icon: <ExclamationCircleOutlined />,
    //   content: 'หากคุณลบข้อมูลนี้ ตัวแพลนที่เกี่ยวข้องกับงานนี้จะถูกลบด้วยเช่นกัน คุณต้องการดำเนินการลบข้อมูลต่อหรือไม่',
    //   okText: 'ใช่',
    //   cancelText: 'ไม่',
    //   onOk:{this.hideModal}
    // });

    return(
      <Modal
          title="กรุณายืนยันการลบข้อมูล"
          visible={this.state.visible_del}
          onOk={this.onModalOK}
          onCancel={this.onModalCancel}
          okText="ใช่"
          cancelText="ไม่"
        >
          <p>หากคุณลบข้อมูลนี้ ตัวแพลนที่เกี่ยวข้องกับงานนี้จะถูกลบด้วยเช่นกัน คุณต้องการดำเนินการลบข้อมูลต่อหรือไม่</p>
        </Modal>
    );
  }

  onModalDelOK = async () => {
    //console.log('onModalDelOK');
    const { item_del } = this.state
    console.log(item_del,'spDeleteDetailById item_del');
    const spDeleteDetailById = await Api.post("spDeleteMainPlanning", {
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
      emp_service_pm_id: item_del.emp_service_pm_id
    })

    console.log(spDeleteDetailById,'await spDeleteDetailById');

    const plan_manual = await Api.post("getAllPlanningMain", {
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
      auto_gen_job: 0,
      // work_pm_start: moment(this.state.start_date).format("YYYY-MM-DD"),
      // work_pm_end: moment(this.state.end_date).format("YYYY-MM-DD"),
    });

    

    this.setState({
      visible_manual_del : false,
      count_plan : plan_manual.data.data.length,
      data_plan : plan_manual.data.data
      //count_all : count_job
    })
  }

  onModalDelCancel = () => {    
    console.log('onModalDelCancel');
    this.setState({
      visible_manual_del : false
    })
  }

  onModalDelConfirm(){    
    return(
      <Modal
          title="กรุณายืนยันการลบข้อมูล"
          visible={this.state.visible_manual_del}
          onOk={this.onModalDelOK}
          onCancel={this.onModalDelCancel}
          okText="ใช่"
          cancelText="ไม่"
        >
          <p>คุณต้องการลบข้อมูลใช่หรือไม่?</p>
        </Modal>
    );
  }

  onSelectTab(index) {
    console.log(index);
    if (index === 0) {
      this.renderDetail(0, this.state.team[0], "job");
      this.setState({
        active: 0,
        active_tab: index,
      });
    } else if (index === 1) {
      //this.renderDetail(0, this.state.team[0], "team");
      this.setState({
        active: 0,
        active_tab: index,
      });
    // } else if (index === 1) {
    //   this.renderDetail(0, this.state.team[0], "team");
    //   this.setState({
    //     active: 0,
    //     active_tab: index,
    //   });
    } else if (index === 2) {
      this.renderDetail(0, this.state.employee[0], "emp");
      this.setState({
        active: 0,
        active_tab: index,
      });
    }
  }

  handleChangeRangePicker = async(range) => {
    const {active_tab } = this.state
    const valueOfInput1 = range[0].format();
    const valueOfInput2 = range[1].format();

    console.log('start date',valueOfInput1); 
    console.log("end date",valueOfInput2);
    const s_date = moment(new Date(valueOfInput1)).format("YYYY/MM/DD")
    const e_date   = moment(new Date(valueOfInput2)).format("YYYY/MM/DD")
    console.log('handleChangeRangePicker s_date : '+s_date+' ,e_date : '+e_date);
    if(active_tab === 0){
      //filter job
      const data_job = await Api.post("v2/jobNoAssetCalenderAll", {
        team_group_id: 0,
        team_id:0,
        company_id: Cookies.get("companyid"),
        operator_id: Cookies.get("operator_id"),
        project_id: Cookies.get("project_id"),
        work_pm_start: s_date,
        work_pm_end: e_date,
        group_id: null ,
        group_name: null,
      });
      

      console.log('data_job',data_job);
      
      let count_job = 0;
      let JobAll = data_job
      //console.log('JobAll handleChangeRangePicker',JobAll);
      if(JobAll.data.data !== undefined || JobAll.data.data.length !== 0){
        //console.log('JobAll : ',JobAll.data.data)
        for(let i=0;i<JobAll.data.data.length;i++){
          count_job += JobAll.data.data[i]['asset_calender_detail'].length
          for(let j=0;j<JobAll.data.data[i]['asset_calender_detail'].length;j++){          
            if(JobAll.data.data[i]['asset_calender_detail'][j].asset_id === null){              
              JobAll.data.data[i]['asset_calender_detail'][j].asset_id = 'Asset List (ID:'+JobAll.data.data[i]['asset_calender_detail'][j].emp_service_pm_id+')'
              JobAll.data.data[i]['asset_calender_detail'][j].asset_code = 'Asset List (ID:'+JobAll.data.data[i]['asset_calender_detail'][j].emp_service_pm_id+')'
            }
            
          }
        }
        //this.renderDetail(0, JobAll.data.data[0], "job");
      }
      this.setState({
        data_job:JobAll.data.data,
        start_date: s_date,
        end_date: e_date,
        count_all : count_job
      })


      
    }//end if job
    
  }
  goToMAList(){
    // go to ma list
    Cookies.set('status', 3)
    window.location.assign("/MaxiOperation/ma_list#")
  }

  changeDisplayList(act){
    console.log(act,'act');
    let ch = 0
    if(act === 1){
      ch = 1
    }else{
      ch = 0
    }

    this.setState({
      active : ch
    })
  }


  SearchOnPlan(search_text){
    const {active_tab ,data_job} = this.state
    // console.log('search_text', search_text);
    // console.log('active_tab', active_tab);
    
    if(active_tab === 0 && search_text !== ""){
      // const data = data_job
      //search job
      // console.log('start_date',start_date);
      // console.log('end date',end_date);
      console.log('data_job',data_job);

      data_job.map((item, index) => (
        console.log('item',item.asset_calender_detail)
      ))


      /*let data_filter = data.filter(item => {
        return (
          Object.keys(item).some((k) =>{
            if(k === "asset_detail_count"){
              
            }

            console.log(item[k])
            console.log(k)
          }
            
            //String(item[k]).toLowerCase().includes(search_text.toLowerCase())
          )
        )
      });
      console.log('data_filter',data_filter);*/

    }
    
  }

  renderJob(){
    const { data_job  } = this.state;
    const columns = this.columns;

    return (
     
        <Collapse className="planning-list" defaultActiveKey={["0"]}>
        {data_job.map((item, index) => (
          <Panel
            header={<span className="font-thai-b font24">{moment(item.emp_work_pm_start).format("DD MMMM YYYY")}</span>}
            key={index}
            extra={<span className="font-thai-b font24" style={{paddingRight:10}}>{item.asset_calender_detail.length} Plan</span>}
          >
            <Table
              rowKey="asset_code"
              columns={columns}
              dataSource={item.asset_calender_detail}
              pagination={false}
            />
          </Panel>
        ))}
      </Collapse>
   
      
    );
  }

  renderPlan(){
    const { selectedRowKeys , currentPage } = this.state;
    const columns = this.columns;
    
    const rowSelection = {
      selectedRowKeys,
      onChange: async (selectedRowKeys, selectedRows) => {
         await JSON.parse(
          JSON.stringify(selectedRowKeys)
        );
        console.log(selectedRowKeys,'selectedRowKeys');
        console.log(selectedRows,'selectedRows');
        
        // let mergeArray = [...selectedRowKeys, ...this.state.selectedRowKeys];
        console.log("state onChange state checkKeys", this.state.checkKeys);
        // this.setState({
        //   setDataAssign: selectedRows,
        // });

        //this.state.set_asset_list.push(selectedRows);

        // this.setState({
        //   //asset_list :  [selectedRows , ...this.state.asset_list]
        //   array_list : selectedRows
        // })
        this.setState(
          {
            array_list: selectedRows,
            selectedRowKeys: selectedRowKeys,
          });

          //disabled_button
          let setDisable = false
          console.log(this.state.array_list,'array_list');
          if(this.state.array_list === undefined || this.state.array_list.length === 0){
            //array empty
            
            setDisable = true
          }else{
            //array is not empty
            setDisable = false
          }

          this.setState({
            disabled_button : setDisable
          })
      },
      onSelect: async (record, selected, selectedRows, nativeEvent) => {
        console.log("record and selected value(T/F)", record, selected);
      },
      getCheckboxProps: (record) => ({
        disabled: record.name === "Disabled User",
        name: record.name,
      }),
    };
    

    return (
      <div className="col-12">
        <div className="d-flex justify-content-between" 
                  style={{                 
                    marginBottom: "15px",                
                  }}
                >
            <ul className="navTwo" style={{ visibility: "hidden" }}>
              <li>
                <div>
                  <span className="font-thai-sb font18 mr-2">Month</span>
                  <DatePicker onChange={this.onSelectMonth} picker="month" />
                </div>
              </li>
              <li>
                <span className="font-thai-sb font18 mr-2">Team Group</span>
                <Select
                  placeholder="Please select"
                  optionFilterProp="children"
                  className="font-mont-r font12"
                >
                  <Option value="">All</Option>
                  <Option value="jack">Team 01</Option>
                  <Option value="lucy">Team 02</Option>
                  <Option value="tom">Team 03</Option>
                </Select>
              </li>
              <li>
                <span className="font-thai-sb font18 mr-2">Team Sub</span>
                <Select
                  placeholder="Please select"
                  optionFilterProp="children"
                  className="font-mont-r font12"
                >
                  <Option value="">All</Option>
                  <Option value="jack">Team Sub 01</Option>
                  <Option value="lucy">Team Sub 02</Option>
                  <Option value="tom">Team Sub 03</Option>
                </Select>
              </li>
            
            </ul>
            <button
              type="button"
              className="btn btn-warning"
              // onClick={() => this.openJob()}
              onClick ={() => this.setState({visible_start_end: true})}
              disabled={this.state.disabled_button}
            >
              {/* <img src="./icon/plus.svg" className="mr-2" /> */}
              <img
                src={ChangePath.absoluteUrl("/icon/plus.svg")}
                className="mr-2"
                alt="plus-ic"
              />
              Generate Job
            </button>
          </div>
        <Table
                size="middle"
                rowKey="emp_service_pm_id"
                rowSelection={rowSelection}
                columns={columns}
                // rowKey={record =>record.asset_id} //This one must be selected
                pagination={{
                  onChange: (page) => this.setState({ currentPage: page }),
                  current: currentPage,
                }}
                dataSource={this.state.data_plan}
              />
      </div>
      
    );
  }

  async openJob(values){
    console.log(values);
    const { selectedRowKeys } = this.state;
    console.log(selectedRowKeys,'selectedRowKeys openJob');

    await this.setState({
      loading_start_end: true
    })

    let emp_service_pm_id_data = ""
    if(selectedRowKeys === undefined || selectedRowKeys.length == 0){
      console.log('array empty');
    }else{
      console.log('array is not empty');
      selectedRowKeys.map((item, index) => {
        console.log(item,'item');
        console.log(index,'index');
        emp_service_pm_id_data += item
        if(index !== selectedRowKeys.length-1){
          emp_service_pm_id_data += ','
        }
      });

      console.log(emp_service_pm_id_data,'emp_service_pm_id_data');

      const openManual = await Api.post("v2/openJobManualAtPlanning", {
        emp_service_pm_id_data: emp_service_pm_id_data,
        company_id: Cookies.get("companyid"),
        operator_id: Cookies.get("operator_id"),
        project_id: Cookies.get("project_id"),
        create_by: Cookies.get("username"),
        plan_start_date: moment(values.start_date).format("YYYY-MM-DD") ,
        plan_end_date: moment(values.end_date).format("YYYY-MM-DD"),
      });
      console.log(openManual.data);
      
      if(openManual.data.result.code.toLowerCase() === "p"){
        await this.setState({
          visible_success:true,
          loading_start_end: false
        })
      } else {
        await this.setState({
          visible_fail:true,
          modal_log: openManual.data.result.showText,
          loading_start_end: false
        })
      }

      await this.setState({
        loading_start_end: false
      })
    }
  }

    // when press scan
  renderStartEnd = () => {
      // const {loading_read_storage} = this.state;
      return (
          <Modal
              centered
              visible={this.state.visible_start_end}
              footer={null}
              closable={true}
              
              // width={900}
              destroyOnClose={false}
              onCancel={() => this.setState({
                  visible_read_storage_folder: false
              })}
              title={<><h4 className="font-mont-b c-blue">Choose Start - End Date</h4></>}
              bodyStyle={{
                  // marginTop: "5%",
                  paddingTop: "0",
                  paddingLeft: "15px",
                  paddingRight: "15px",
                  paddingBottom: "0",
                  borderBottom: "0px"
              }}
          >   

              <div className="container ">
                  <Spin spinning={this.state.loading_start_end}>
                  <Form onFinish={(values) => this.openJob(values)} ref={this.startEnd}  layout="vertical">
                  <div className="row">
                          <div className="col-12  mb-3 ">
                                  <div className="row">
                                      <div className="col-6">
                                          <Form.Item
                                              name="start_date"
                                              label="Start Date"
                                              rules={[{ required: true, message: "Start date is required" }]}
                                          >
                                              <DatePicker  picker="date" format={dateFormatList[0]} style={{width: "100%"}} />
                                          </Form.Item>
                                      </div>
                                      <div className="col-6">
                                      <Form.Item
                                              name="end_date"
                                              label="End Date"
                                              rules={[{ required: true, message: "End date is required" }]}
                                          >
                                              <DatePicker  picker="date" format={dateFormatList[0]} style={{width: "100%"}} />
                                          </Form.Item>
                                      </div>
                                  </div>
                          </div>
                      </div>
                      <div className="row">
                          <div className="col-12  mb-3" style={{ textAlign: "center" }}>
                          <button
                              type="reset"
                              className="btn btn-secondary"
                              onClick={() => this.setState({
                                 visible_start_end: false
                              })}
                          >
                              <span style={{ fontSize: "16px" }}>Close</span>
                          </button>
                          <button
                              type="submit"
                              className="btn btn-warning ml-2"
                              // onClick={() => this.handleGenerateFolder(this.genFolder.current.getFieldsValue(true))}
                          >
                              <span style={{ fontSize: "16px" }}>Confirm</span>
                          </button>
                      </div>
                      </div>
                      </Form>
                      </Spin>
                  </div>
          </Modal>
      )
  }

  renderSuccess() {
    const { visible_success } = this.state;
    return (
      <Modal
        title={null}
        centered
        visible={visible_success}
        footer={null}
        closable={false}
      >
        <div className="text-center">
          <img
            src={ChangePath.absoluteUrl("/img/modal_approve.svg")}
            className="img-fluid"
            alt="img-fl-ic"
          />
          <h3 className="font-mont-sb font18 c-blue mt-3">
            Generate Successful
          </h3>
          <button
            onClick={() => {
              this.setState({ visible_success: false});
              this.goToMAList()
              //this.setState({ visible_success: false, currentPage: 1 });
            }}
            className="btn btn-secondary"
          >
            OK
          </button>
        </div>
      </Modal>
    );
  }

  renderFailed() {
    const { visible_fail } = this.state;
    return (
      <Modal
        title={null}
        centered
        visible={visible_fail}
        footer={null}
        closable={false}
      >
        <div className="text-center">
          <img
            src={ChangePath.absoluteUrl("/img/statusinfo_error.svg")}
            className="img-fluid"
            width="300"
            alt="ig-fl-01"
          />
          <h3 className="font-mont-sb font18 c-blue mt-3">
            Generate Failed: {this.state.modal_log}
          </h3>
          <button
            onClick={() => {
              this.setState({ visible_fail: false});
              // this.goToMAList()
              //this.setState({ visible_success: false, currentPage: 1 });
            }}
            className="btn btn-secondary"
          >
            OK
          </button>
        </div>
      </Modal>
    );
  }

  renderDataTeam() {
    const { data_team } = this.state;
    const columns = this.columns
    return (
      <Collapse className="planning-list" defaultActiveKey={["0"]}>
        {data_team.map((item, index) => (
          <Panel
            header={
              <span className="font-thai-b font24" style={{ left: "15px" }}>
                {moment(item.emp_work_pm_start).format("DD MMMM YYYY")}
              </span>
            }
            key={index}
            extra={
              <span className="font-thai-b font24 mr-3" style={{ left: "15px" }}>
                {item.sum} Asset
              </span>
            }
          >
            <Collapse defaultActiveKey={["0"]}>
              {item.asset.map((subitem, index) => (
                <Panel
                  header={
                    <span className="c-blue font-thai-b font18">
                      {subitem.emp_name} (Asset : {item.asset.length})
                    </span>
                  }
                  key={index}
                >
                  <Table
                    // rowKey="asset_code"
                    columns={columns}
                    dataSource={[subitem]}
                    pagination={false}
                  />
                </Panel>
              ))}
            </Collapse>
          </Panel>
        ))}
      </Collapse>
    );
  }

  renderDataEmployee() {
    const { data_emp } = this.state;
    const columns = this.columns
    return (
      <Collapse className="planning-list" defaultActiveKey={["0"]}>
        {data_emp.map((item, index) => (
          <Panel
            header={<span className="font-thai-b font24">{moment(item.emp_work_pm_start).format("DD MMMM YYYY")}</span>}
            key={index}
            extra={<span className="font-thai-b font24">{item.sum} Asset</span>}
          >
            <Table
              rowKey="asset_code"
              columns={columns}
              dataSource={[item.asset]}
              pagination={false}
            />
          </Panel>
        ))}
      </Collapse>
    );
  }

  renderDetail = async (index, item, type) => {
    //console.log('renderDetail');
    
    // console.log(index,'index');
    // console.log(item,'item');
    // console.log(type,'type');
      if(type === "job"){
        // select planning job (no assign team and emp)
        /*const s_date = this.state.start_date
        const e_date   = this.state.end_date
        const DeatilList = await Api.post("jobNoAssetCalenderAll", {
          team_group_id: 0,
          team_id:0,
          company_id: Cookies.get("companyid"),
          work_pm_start: s_date,
          work_pm_end: e_date,
          // limit: "50",
          // offset: "0",
        });
        console.log(DeatilList,'DeatilList');*/

        // for(let i=0;i<DeatilList.length;i++){
        //   console.log('asset_calender_detail',DeatilList.asset_calender_detail);
        // }

        this.setState({ active: index, data_job: item });

      }
      /*else if(type === "team"){
         const DeatilList = await Api.post("planningJobTeamDetail", {
          team_group_id: item.team_group_id,
          //team_group_id:1,
          company_id: Cookies.get("companyid"),
          work_pm_start: item.pm_start_day,
          work_pm_end: item.pm_end_day,
          limit: "50",
          offset: "0",
        });
        console.log(DeatilList,'DeatilList');
        
         this.setState({ active: index, data_team: DeatilList.data.data });
      }
      else if(type === "emp"){
        this.setState({ active: index});
        const DeatilList = await Api.post("planningJobEmployeeDetail", {
          employee_id: item.employee_id,
          company_id: Cookies.get("companyid"),
          work_pm_start: item.pm_start_day,
          work_pm_end: item.pm_end_day,
          limit: "50",
          offset: "0",
        });
    
    this.setState({ active: index, data_emp: DeatilList.data.data });
      }*/

    // console.log(DeatilList.data.data);
  };

  render() {
    const {  active, active_tab, employee, tab } = this.state;
    // const columns = this.columns
    return (
      <div style={{ padding: "20px" }}>
        {this.renderStartEnd()}
        <div className="row">
          <div className="col-3">
            <ul className="tab-list-plan">
              {tab.map((item, index) => (
                <li 
                className={active_tab === index ? "active" : ""}
                >
                  {/* <button onClick={() => this.onSelectTab(index)}> */}
                  <button >
                    <Translate text={item.title} />
                  </button>
                </li>
              ))}
            </ul>
            {/* {active_tab === 0
            ? (
              <div
                key={0}
                className={
                  active === 0
                    ? "card-planning-list active"
                    : "card-planning-list"
                }
              >
                <a
                  className="d-flex justify-content-between align-items-center"
                  // onClick={this.goToMAList}                  
                >
                  <span className="name font-thai-b font18">
                    No Assign
                  </span>
                  <span className="font-thai-r font16">
                    Plan : {this.state.count_all}
                  </span>
                </a>
              </div>
            ):''
            } */}
              <div
                key={0}
                className={
                  active === 0
                    ? "card-planning-list active"
                    : "card-planning-list"
                }
              >
                <a
                  className="d-flex justify-content-between align-items-center"
                  onClick={() => this.changeDisplayList(0)}
                  // onClick={this.goToMAList}                  
                >
                  <span className="name font-thai-b font18">
                    No Assign
                  </span>
                  <span className="font-thai-r font16">
                    Plan : {this.state.count_all}
                  </span>
                </a>
              </div>
            
              <div
                key={1}
                className={
                  active === 1
                    ? "card-planning-list active"
                    : "card-planning-list"
                }
              >
                <a
                  className="d-flex justify-content-between align-items-center"
                  // onClick={this.goToMAList}
                  onClick={() => this.changeDisplayList(1)}
                >
                  <span className="name font-thai-b font18">
                    Manual
                  </span>
                  <span className="font-thai-r font16">
                    Plan : {this.state.count_plan}
                  </span>
                </a>
              </div>
            

            {/* {active_tab === 1
              ? team.map((item, index) => (
                  <div
                    key={index}
                    className={
                      active === 1
                        ? "card-planning-list active"
                        : "card-planning-list"
                    }
                  >
                    <a
                      className="d-flex justify-content-between align-items-center"
                      onClick={() => this.renderDetail(index, item, "team")}
                    >
                      <span className="name font-thai-b font18">
                        Team {item.team_name}
                      </span>
                      <span className="font-thai-r font16">
                        Asset : {item.asset_own_total}
                      </span>
                    </a>
                  </div>
                )):''
          } */}

          {active_tab === 2
            ? employee.map((item, index) => (
                  <div
                    key={index}
                    className={
                      active === index
                        ? "card-planning-list active"
                        : "card-planning-list"
                    }
                  >
                    <button
                      className="w-100"
                      onClick={() => this.renderDetail(index, item, "emp")}
                    >
                      <img
                        className="float-left mr-3"
                        src={Api.absoluteUrl("/img/1.png")}
                        alt=""
                        width="40"
                      />
                      <div className="text-left">
                        <h5 className="font-thai-b font18 mb-0">
                          {item.emp_name}
                        </h5>
                        <span>
                          {item.asset_own_total} {" Jobs "}
                        </span>
                      </div>
                    </button>
                  </div>
                )):''
              }

            {/* {active_tab === 1
              ? team.map((item, index) => (
                  <div
                    key={index}
                    className={
                      active === index
                        ? "card-planning-list active"
                        : "card-planning-list"
                    }
                  >
                    <a
                      className="d-flex justify-content-between align-items-center"
                      onClick={() => this.renderDetail(index, item, "team")}
                    >
                      <span className="name font-thai-b font18">
                        Team {item.team_name}
                      </span>
                      <span className="font-thai-r font16">
                        Asset : {item.asset_own_total}
                      </span>
                    </a>
                  </div>
                ))
              : employee.map((item, index) => (
                  <div
                    key={index}
                    className={
                      active === index
                        ? "card-planning-list active"
                        : "card-planning-list"
                    }
                  >
                    <button
                      className="w-100"
                      onClick={() => this.renderDetail(index, item, "emp")}
                    >
                      <img
                        className="float-left mr-3"
                        src={Api.absoluteUrl("/img/1.png")}
                        alt=""
                        width="40"
                      />
                      <div className="text-left">
                        <h5 className="font-thai-b font18 mb-0">
                          {item.emp_name}
                        </h5>
                        <span>
                          {item.asset_own_total} {" Jobs "}
                        </span>
                      </div>
                    </button>
                  </div>
                ))} */}
          </div>
          <div className="col-9">
            <div className="mb-3">
              {/* <RangePicker defaultValue={[(this.state.start_date) , (this.state.end_date)]}/> */}
              {active_tab === 0 && active === 0 ?
              (
                <RangePicker
                defaultValue={[
                  moment(this.state.start_date, dateFormatList[1]),
                  moment(this.state.end_date, dateFormatList[1]),
                ]}
                format={dateFormatList[1]}
                onChange={this.handleChangeRangePicker}
              />
              ):''
              }
              
            </div>
            <Input.Group compact className="mb-3">
              {/* <Select
                value=""
                style={{ width: "180px" }}
                onChange={this.handleOptionSearch}
              >
                <Option value="">All Resource</Option>
              </Select> */}

              {/* <Input.Search
                placeholder="Search"
                onSearch={(value) => this.SearchOnPlan(value)}
                style={{ width: "335px" }}
                enterButton
              /> */}

            </Input.Group>
            <h3 className="c-blue font-thai-b font30">
            {/* {moment().startOf('week').format("DD MMMM YYYY")} {"-"}{" "}
            {moment().endOf('week').format("DD MMMM YYYY")} */}
            {active_tab === 0 && active === 0 ?
              (
                moment(this.state.start_date).format("DD MMMM YYYY")
              ):''
            }
            {active_tab === 0 && active === 0 ?
            " - ":""
            }
            
            {active_tab === 0 && active === 0 ?
              (
                moment(this.state.end_date).format("DD MMMM YYYY")
              ):''
            }

              {/* {moment(this.state.start_date).format("DD MMMM YYYY")} {"-"}{" "}
              {moment(this.state.end_date).format("DD MMMM YYYY")} */}

              
            </h3>
            {active_tab === 0 && active === 0 ? this.renderJob():''}
            {active_tab === 0 && active === 1 ? this.renderPlan():''}
            {active_tab === 1
              ? this.renderDataTeam()
              : ''}
              {active_tab === 2
              ? this.renderDataEmployee()
              : ''}
              {this.onModalConfirm()}
              {this.onModalDelConfirm()}             
              {this.renderSuccess()}
              {this.renderFailed()}

          </div>
        </div>
      </div>
    );
  }
}

export default ListPlan;
